import { render, staticRenderFns } from "./EmployeeGeneralDetail.vue?vue&type=template&id=44daf74c&scoped=true&"
import script from "./EmployeeGeneralDetail.vue?vue&type=script&lang=js&"
export * from "./EmployeeGeneralDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44daf74c",
  null
  
)

export default component.exports